import { Configuration } from "@stacks/blockchain-api-client";

export const STACKS_API_BASE_URL = "https://node.stxscan.co";

export const stacksConfig = new Configuration({
  basePath: STACKS_API_BASE_URL,
});
